<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
      {{ schema.title }}
      <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <div #tagWrapper class="taglist form-control"
    [attr.disabled]="schema.readOnly"
    (click)="wrapperClick( $event )">

    <div #tagItem *ngFor="let tag of selectedTags; index as i; trackBy: tagIdentity"
      [attr.tabindex]="schema.readOnly?null:0"
      class="taglist-tag"
      [attr.data-value]="tag.value"
      (focus)="closeList()"
      (keydown)="tagKeydown( tag, $event )">
      {{ tag.label }}
      <span (click)="checkToggle( tag )"
        *ngIf="!schema.readOnly">&times;</span>
    </div>

    <div #tagSearch [attr.id]="id"
      [attr.hidden]="schema.readOnly"
      [attr.disabled]="schema.readOnly"
      class="taglist-tag taglist-search"
      [class.has-placeholder]="showPlaceholder && placeholder"
      [attr.data-placeholder]="showPlaceholder ? placeholder : null"
      contenteditable
      tabindex="0"
      (focus)="searchFocus( $event )"
      (blur)="searchBlur( $event )"
      (keydown)="searchKeydown( $event )"
      (paste)="cleanPaste( $event )"
      name="listSearch"
      [(ngModel)]="listSearch"></div>

    <ul #tagList class="taglist-options panel panel-default"
      [class.open]="listOpen"
      [class.-up]="openDirection === 'up'"
      [class.-down]="openDirection === 'down'"
      [style.max-height]="maxHeight"
      (blur)="listBlur( $event )"
      tabindex="-1"
      (mousedown)="listFocus( $event )">
      <li *ngFor="let option of searchResults; index as i; trackBy: tagIdentity"
        [class.active]="listSelectedIndex == i"
        (click)="clickListOption( option )">{{ option.label }}</li>
    </ul>

  </div>

  <div *ngIf="exclusiveOptions.length" class="exclusive-options">
    <div *ngFor="let option of exclusiveOptions; index as i; trackBy: tagIdentity" class="checkbox">
      <label class="horizontal control-label">
        <input [attr.name]="name"
          [attr.disabled]="schema.readOnly"
          value="{{ option.value }}" type="checkbox"
          (change)="checkToggle( option )"
          [checked]="isChecked( option.value )" />
        {{ option.label }}
      </label>
    </div>
  </div>

  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/taglist.widget.html